export const users = [
  {
    id: 1,
    username: "owner",
    password: "owner123",
    name: "Owner User",
    email: "owner@example.com",
    role: "owner",
  },
  {
    id: 2,
    username: "finance",
    password: "finance123",
    name: "Finance User",
    email: "finance@example.com",
    role: "finance",
  },
  {
    id: 3,
    username: "manager",
    password: "manager123",
    name: "Manager User",
    email: "manager@example.com",
    role: "manager",
  },
];
